/**
 * lockCopy.ts — the two sentences a frozen policy year says, in one place.
 *
 * `advance/areas/lockCopy.ts`'S RULE, ON THIS DOSSIER'S TWO CANVASES [F7]. The freeze is one rule —
 * `agreement_documents.frozen_at` is set at the FIRST signature, and from that moment the figures
 * the instrument printed cannot move underneath it — and it is drawn twice here: the Policy canvas's
 * cover period and the Advance canvas's whole money grid. Two copies of a sentence naming a control
 * is how two canvases end up pointing an admin at two different doors.
 *
 * IT IS A FUNCTION AND NOT A PAIR OF CONSTANTS, WHICH IS THE ONE DIFFERENCE FROM THE ADVANCE'S. That
 * dossier writes one instrument and names it in a string; this one writes two [D-B45], and a line
 * reading "the Insurance Premium Advance is signed" over a year the driver settled in full would be
 * a sentence about a document that does not exist. The advance's own constants are left exactly as
 * they are — they name the Operational Expense Advance and its Schedule, which is right there and
 * wrong here — and this states the same rule about whichever instrument this year is on.
 *
 * IT NAMES THE REAL CONTROL. "Locked" on its own is a dead end; the correction exists and it is
 * void-and-reissue, in the agreement row's own overflow menu on the Agreement area.
 */

import { INSTRUMENT_TITLES, type InsuranceInstrument } from '@/lib/agreements/instrument';

export interface FrozenLockCopy {
    title: string;
    body: string;
}

export function frozenLock(instrument: InsuranceInstrument): FrozenLockCopy {
    const title = INSTRUMENT_TITLES[instrument];
    return {
        title: `Locked — the ${title} is signed`,
        body:
            `A party has signed the ${title}, so the figures it printed are frozen. To change ` +
            'them, use “Void & reissue” in the agreement row’s overflow menu on the Agreement ' +
            'area: that withdraws the signed instrument and raises a replacement over the ' +
            'corrected figures.',
    };
}
